(function () {
  if (window.__cnFreeGiftWired) return;
  window.__cnFreeGiftWired = true;

  var SECTION_IDS = 'cart-drawer,cart-icon-bubble';

  function showError(msg) {
    var notification = document.querySelector('cart-notification');
    if (notification && typeof notification.renderError === 'function') {
      notification.renderError(msg);
      return;
    }
    var existing = document.querySelector('.cart-error-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'cart-error-toast';
    toast.setAttribute('role', 'alert');
    toast.textContent = msg;
    toast.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'left:50%',
      'transform:translateX(-50%)',
      'z-index:9999',
      'background:#353535',
      'color:#fff',
      'padding:14px 22px',
      'border-radius:4px',
      'font-family:var(--font-body-family-override,sans-serif)',
      'font-size:14px',
      'letter-spacing:0.01em',
      'box-shadow:0 8px 24px -10px rgba(0,0,0,0.3)',
      'max-width:90vw'
    ].join(';');
    document.body.appendChild(toast);
    setTimeout(function () {
      toast.style.transition = 'opacity 250ms ease, transform 250ms ease';
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(10px)';
      setTimeout(function () { toast.remove(); }, 260);
    }, 4000);
  }

  function refreshDrawerOrReload() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ sections: SECTION_IDS })
    })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
          drawer.renderContents(parsed);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  async function claim(btn) {
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var code = btn.getAttribute('data-code');

    if (!variantId || isNaN(variantId)) {
      throw new Error('Free gift: missing variant ID');
    }

    var drawer = document.querySelector('cart-drawer');
    var added = false;

    if (drawer && typeof drawer.addItemToCart === 'function') {
      try {
        await drawer.addItemToCart(variantId, 1);
        added = true;
      } catch (e) {
        console.error('[cn-free-gift] drawer.addItemToCart failed', e);
      }
    }

    if (!added) {
      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!addRes.ok) {
        var txt = '';
        try { txt = await addRes.text(); } catch (_) {}
        var msg = 'Could not add free creatine to cart.';
        try {
          var parsed = JSON.parse(txt);
          if (parsed && parsed.description) msg = parsed.description;
        } catch (_) {}
        console.error('[cn-free-gift] /cart/add.js failed', addRes.status, txt);
        throw new Error(msg);
      }
    }

    if (code) {
      try {
        await fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
        await refreshDrawerOrReload();
      } catch (e) {
        console.warn('[cn-free-gift] discount apply failed', e);
      }
    }
  }

  async function removeGift(btn) {
    var lineKey = btn.getAttribute('data-line-key');
    if (!lineKey) {
      throw new Error('Free gift: missing line key');
    }
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (!res.ok) {
      throw new Error('Could not remove free creatine.');
    }
    await refreshDrawerOrReload();
  }

  document.addEventListener('click', function (e) {
    var claimBtn = e.target.closest('[data-cn-free-gift-claim]');
    var removeBtn = e.target.closest('[data-cn-free-gift-remove]');
    if (!claimBtn && !removeBtn) return;
    e.preventDefault();
    var btn = claimBtn || removeBtn;
    if (btn.disabled) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Working…';

    var p = claimBtn ? claim(claimBtn) : removeGift(removeBtn);
    p.catch(function (err) {
      console.error('[cn-free-gift]', err);
      if (document.body.contains(btn)) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
      showError((err && err.message) || 'Something went wrong.');
    });
  });
})();
